"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var MaterialApi = /** @class */ (function () {
    function MaterialApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 获取上传Url(上传使用PUT方法)
     * @method GET 获取上传Url(上传使用PUT方法)
     *
     * @params fileName 无说明
     */
    MaterialApi.prototype.uploadurl = function (fileName) {
        return this.http
            .url("/api/Material/" + fileName + "/uploadurl")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 添加素材,查询素材列表
     * @method POST 添加素材
     * @method GET 查询素材列表
     *
     */
    MaterialApi.prototype.Material = function () {
        return this.http
            .url("/api/Material")
            .addSecurityHeaders()
            .support('POST', 'GET');
    };
    /**
     * 删除素材
     * @method DELETE 删除素材
     *
     * @params id 无说明
     */
    MaterialApi.prototype.MaterialById = function (id) {
        return this.http
            .url("/api/Material/" + id)
            .addSecurityHeaders()
            .support('DELETE');
    };
    MaterialApi.diOptions = di_1.default.options({
        name: "MaterialApi",
        scope: "Singleton"
    });
    return MaterialApi;
}());
exports.MaterialApi = MaterialApi;
exports.default = MaterialApi;
